export default class Message {
  constructor({ id, text, sender, attachment, channelId, showDay = false, lastDay = false, pinned = false, isCall = false, isNotification = false }) {
    this.id = id;
    this.text = text;
    this.attachment = attachment;
    this.channelId = channelId;
    this.sender = sender;
    this.showDay = showDay;
    this.lastDay = lastDay;
    this.pinned = pinned;
    this.isCall = isCall;
    this.isNotification = isNotification;
  }
}